import { render, staticRenderFns } from "./crossChainRecord.vue?vue&type=template&id=1e9d0472&scoped=true&"
import script from "./crossChainRecord.vue?vue&type=script&lang=js&"
export * from "./crossChainRecord.vue?vue&type=script&lang=js&"
import style0 from "./crossChainRecord.vue?vue&type=style&index=0&id=1e9d0472&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9d0472",
  null
  
)

export default component.exports